



















import { UsualPower } from '@/services/api/usual-power/usual-power'
import { compareUsualPower, UsualPowerComparisonResult } from '@spa/components/organisms/cart/model/item/usual-power-comparison'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class UsualPowerComparisonMessage extends Vue {
  @Prop({ required: true })
  usualPowerInfo: UsualPower | null

  @Prop({ required: true })
  itemPowerPathname: string | null

  get comparisonResult(): UsualPowerComparisonResult | null {
    return compareUsualPower(this.usualPowerInfo, this.itemPowerPathname)
  }
}
